import React, { useRef, useState } from 'react'
import { useField } from 'react-final-form'
import { FieldValidator } from 'final-form'
import {
    UseUploadFileType,
    MyFileType,
    SubTopicPageList,
    ReturnDataType,
    NewReturnListFileType,
    UploadResponseType,
} from './uploadFileTypeTest'
import { composeValidators, uploadRequired } from '../../../../../utilities/validate'
import useAppAlertMessageAction from '../../../../../stores/appAlertMessage/appAlertMessageAction'
import useWebService from '../../../../../services/web/useWebService'
import useTranslate from '../../../../../i18n/useTranslate'

const useUploadFile = (props: UseUploadFileType) => {
    const { required, requiredErrorMessage, validates = [], onChangeUpload, initialData, topicID } = props
    const appAlertMessageAction = useAppAlertMessageAction()
    const callWebService = useWebService()
    const translate = useTranslate()
    const refElementUpload = useRef<any>()
    const refElementTextField = useRef<any>()
    const [lstFileUpload, setLstFileUpload] = useState<NewReturnListFileType[]>()
    const [returnData, setReturnData] = useState<ReturnDataType>()

    const { name } = props

    React.useEffect(() => {
        initialData.forEach((upload: any) => {
            if (upload.uploadFileObj.documentTopicID === topicID) {
                if (upload.uploadFileObj.fileList.length > 0) {
                    setLstFileUpload(upload.uploadFileObj.fileList)
                }
            }
        })
    }, [JSON.stringify(initialData)])
    const mergeValidate = () => {
        let validate: Array<FieldValidator<any>> = []
        if (typeof required === 'boolean' && required) {
            validate = [uploadRequired(requiredErrorMessage), ...validates]
        }

        return validate
    }

    const field = useField<string>(name, {
        validate: composeValidators(...mergeValidate()),
    })

    const handleClickUpload = () => {
        refElementUpload.current.click()
    }
    const handleChangeUpload = async (event: any, mainTopicID: number) => {
        const fileList: FileList = event.target.files
        let lstFile: Array<MyFileType> = []
        let lstDisplayName: Array<string> = []
        const numFiles = fileList.length
        const numMaxUploadFile = Number(process.env.REACT_APP_MAX_UPLOAD_FILE_DOCUMENT)
        if (numFiles > 0) {
            for (let i = 0; i < numFiles; i++) {
                const file: MyFileType = fileList[i]
                file.fileID = `${i}_${fileList[i].lastModified}_${fileList[i].name}`
                if (fileList[i].size > 31457280 || numFiles > numMaxUploadFile) {
                    //10 mb to byte (1 mb = 1048576 byte)
                    appAlertMessageAction.openAlertMessage({
                        title: translate.get('ALERT.TITLE.WARNING'),
                        message: translate.get('ALERT.CONTENT.UPLOAD_NOT_EXCEED_FILE', [String(numMaxUploadFile)]),
                    })

                    lstFile = []
                    lstDisplayName = []

                    break
                }
                lstFile.push(file)
                lstDisplayName.push(file.name)
            }
        }

        // --- ############################################################################## --- //

        const uploadRes = await callUploadFile(lstFile, mainTopicID)
        let myNewListFile: NewReturnListFileType[]

        myNewListFile = uploadRes.map((itm: UploadResponseType) => {
            return {
                documentTopicID: mainTopicID,
                fileToken: `${itm.fileToken}`,
                filename: itm.filename,
                fileID: `${itm.fileToken}`,
            }
        })
        setLstFileUpload(myNewListFile)
        const newReturnData = { ...returnData, fileList: myNewListFile, documentTopicID: mainTopicID }
        setReturnData(newReturnData)
        field.input.onChange(newReturnData)
        refElementTextField.current.value = lstDisplayName.join(', ')
    }

    const callUploadFile = async (fileList: Array<MyFileType>, mainTopicID: number) => {
        var formData = new FormData()
        fileList.forEach((file: MyFileType) => {
            formData.append('files', file)
        })

        const res = await callWebService.uploadFileTemp(formData)
        return res.result

        // setDocLst(lstDisplayName)
    }
    const handleClickClear = (file: any) => {
        // file: MyFileType
        let currentValue: ReturnDataType = field.input.value as unknown as ReturnDataType
        const newLstFile = currentValue.fileList?.filter((itm) => itm.fileID !== file.fileID)
        let newReturnData = { ...returnData, fileList: newLstFile }
        if (newLstFile?.length === 0) {
            newReturnData = { ...returnData, fileList: newLstFile, subTopicPageList: [] } //กรณีลบไฟล์ออกหมดจะให้เคลียร์ค่า page ออกด้วย
        } else {
            newReturnData = { ...returnData, fileList: newLstFile }
        }
        setReturnData(newReturnData)
        field.input.onChange(newReturnData)
        setLstFileUpload(newLstFile)
        refElementTextField.current.value = newLstFile?.join(', ')
    }

    const handleChangeInputPage = (page: string, subTopicID: number, mainTopicID?: number | null) => {
        let obj = { page: page, subtopicID: subTopicID }

        // --- Logic --- //
        //1. delete old value
        //2. push new value
        let newReturnData = null
        if (returnData?.subTopicPageList && returnData?.subTopicPageList?.length > 0) {
            const deletedOldSubTopicList = returnData.subTopicPageList.filter((itm: SubTopicPageList) => {
                //delete old value
                return itm.mainTopicID != mainTopicID || itm.subTopicID != subTopicID
            })
            let newSubTopicPageList = [...deletedOldSubTopicList, { ...obj }] //push new value
            newReturnData = { ...returnData, subTopicPageList: newSubTopicPageList }
            setReturnData(newReturnData)
            field.input.onChange(newReturnData)
        } else {
            newReturnData = { ...returnData, subTopicPageList: [obj] }
            setReturnData(newReturnData)
            field.input.onChange(newReturnData)
        }
    }
    return {
        refElementUpload,
        refElementTextField,
        field,
        lstFileUpload,
        onClickUpload: handleClickUpload,
        onChangeUpload: handleChangeUpload,
        onClickClear: handleClickClear,
        onChangeInputPage: handleChangeInputPage,
    }
}

export default useUploadFile
